<pagination
  [boundaryLinks]="true"
  [rotate]="true"
  [directionLinks]="true"
  [totalItems]="data!.meta!.total"
  [itemsPerPage]="data!.meta!.per_page"
  [maxSize]="10"
  [ngModel]="data!.meta.current_page"
  (pageChanged)="goToPage.next($event.page)"
  [customFirstTemplate]="firstTemplate"
  [customLastTemplate]="lastTemplate"
  [customPreviousTemplate]="prevTemplate"
  [customNextTemplate]="nextTemplate"
></pagination>

<ng-template #nextTemplate let-disabled="disabled" let-currentPage="currentPage">
  <i class="fas fa-arrow-right" [class.text-muted]="disabled"></i>
</ng-template>

<ng-template #prevTemplate let-disabled="disabled" let-currentPage="currentPage">
  <i class="fas fa-arrow-left" [class.text-muted]="disabled"></i>
</ng-template>

<ng-template #lastTemplate let-disabled="disabled" let-currentPage="currentPage">
  <i class="fas fa-step-forward" [class.text-muted]="disabled"></i>
</ng-template>

<ng-template #firstTemplate let-disabled="disabled" let-currentPage="currentPage">
  <i class="fas fa-step-backward" [class.text-muted]="disabled"></i>
</ng-template>
